export default __webpack_public_path__ + "static/media/share.35d8dac4.svg";